var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixAppmarketV1AppPlans from '@wix/ambassador-appmarket-v1-app-plans/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var DurationUnit;
(function (DurationUnit) {
    /** unknown interval unit */
    DurationUnit["UNKNOWN_UNIT"] = "UNKNOWN_UNIT";
    /** month */
    DurationUnit["MONTH"] = "MONTH";
    /** year */
    DurationUnit["YEAR"] = "YEAR";
})(DurationUnit || (DurationUnit = {}));
export var CycleType;
(function (CycleType) {
    CycleType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    CycleType["ONE_TIME"] = "ONE_TIME";
    CycleType["RECURRING"] = "RECURRING";
})(CycleType || (CycleType = {}));
export var TaxType;
(function (TaxType) {
    TaxType["NOT_APPLICABLE"] = "NOT_APPLICABLE";
    TaxType["VAT"] = "VAT";
    TaxType["GST"] = "GST";
})(TaxType || (TaxType = {}));
const _listAppPlansByAppIdRequest = {};
const _listAppPlansByAppIdResponse = {};
/**
 * Retrieves plans for the given apps.
 *
 *
 * Also returns tax settings and currency details. Wix calculates this information
 * based on the 2-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements)
 * format that you pass in the call's header. If you don't pass a country code in
 * the header, Wix calculates the tax settings and currency details based on the
 * call's IP address. Note that the tax settings and currency details may not resolve
 * properly if you call through a VPN.
 *
 * Prices for plans that are managed outside of Wix aren't returned.
 *
 * Consumers must pay for yearly and multi-yearly plans of your app every month.
 * For these plans this endpoint returns the price that the consumer must pay every
 * month and not the total price for the entire year.
 *
 * <blockquote class="important">
 *
 * __Important:__
 * The App Plans API doesn't follow any tenancy model. You don't need any
 * permissions to call `List App Plans by App ID`.
 *
 * </blockquote>
 * @param appIds - List of app IDs to retrieve plans for.
 *
 * Min: 1 app ID
 * Max: 100 app IDs
 * @public
 * @documentationMaturity preview
 * @requiredField appIds
 * @adminMethod
 */
export function listAppPlansByAppId(appIds) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { appIds: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listAppPlansByAppIdRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listAppPlansByAppIdResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#appPlans']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([appIds]);
        const reqOpts = ambassadorWixAppmarketV1AppPlans.listAppPlansByAppId(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'appIds',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=appmarket-v1-app-plans.universal.js.map